/**
 * Builds an RFC 3339 timestamp with numeric offset from the browser's local wall clock:
 * calendar day (YYYY-MM-DD) + due time. Used for campaign dueDate (API variant 1).
 */
export function formatDemandDueDateAsIsoOffset(demandDate: string, dueTime?: string): string | undefined {
  if (!demandDate?.trim()) {
    return undefined;
  }
  const datePart = demandDate.trim().split('T')[0];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
    return undefined;
  }

  const raw = (dueTime?.trim() || '00:00').length === 5 ? `${dueTime?.trim() || '00:00'}:00` : dueTime?.trim() || '00:00:00';
  const segments = raw.split(':');
  const h = parseInt(segments[0] ?? '0', 10);
  const m = parseInt(segments[1] ?? '0', 10);
  const sec = parseInt(segments[2] ?? '0', 10);
  if (Number.isNaN(h) || Number.isNaN(m) || Number.isNaN(sec)) {
    return undefined;
  }

  const y = parseInt(datePart.slice(0, 4), 10);
  const mo = parseInt(datePart.slice(5, 7), 10);
  const d = parseInt(datePart.slice(8, 10), 10);
  const local = new Date(y, mo - 1, d, h, m, sec, 0);

  const pad = (n: number) => String(n).padStart(2, '0');
  const yyyy = local.getFullYear();
  const MM = pad(local.getMonth() + 1);
  const dd = pad(local.getDate());
  const HH = pad(local.getHours());
  const MMi = pad(local.getMinutes());
  const SS = pad(local.getSeconds());

  const tzOffsetMin = -local.getTimezoneOffset();
  const sign = tzOffsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(tzOffsetMin);
  const offH = pad(Math.floor(abs / 60));
  const offM = pad(abs % 60);

  return `${yyyy}-${MM}-${dd}T${HH}:${MMi}:${SS}${sign}${offH}:${offM}`;
}
